module.exports = __webpack_public_path__ + "static/media/LI1.7f982521.jpg";